import facebook from '../../../Assets/Social/Facebook.png';
import github from '../../../Assets/Social/Github.png';
import gmail from '../../../Assets/Social/Gmail.png';
import instagram from '../../../Assets/Social/Instagram.png';
import linkedin from '../../../Assets/Social/LinkedIn.png';
import snapchat from '../../../Assets/Social/Snapchat.png';
import discord from '../../../Assets/Social/Spider.png';
import spotify from '../../../Assets/Social/Spotify.png';
import telegram from '../../../Assets/Social/Telegram.png';
import twitter from '../../../Assets/Social/Twitter.png';
import whatsapp from '../../../Assets/Social/Whatsapp.png';

export const data = [
  {
    name: 'Instagram',
    img: instagram,
    color: '#ffffff',
    link: 'https://www.instagram.com/spyware007_/'
  },

  {
    name: 'Github',
    img: github,
    color: '#ffffff',
    link: 'https://github.com/Spyware007'
  },
  {
    name: 'Gmail',
    img: gmail,
    color: '#ffffff',
    link: 'mailto:omgawandeofficial9834899149@gmail.com'
  },
  {
    name: 'Facebook',
    img: facebook,
    color: '#ffffff',
    link: 'https://www.facebook.com/om.gawande.79274/'
  },
  {
    name: 'LinkedIn',
    img: linkedin,
    color: '#ffffff',
    link: 'https://www.linkedin.com/in/om-gawande/'
  },
  {
    name: 'Discord',
    img: discord,
    color: '#ffffff',
    link: 'https://discord.gg/TdcAreKPUA'
  },
  {
    name: 'Snapchat',
    img: snapchat,
    color: '#ffffff',
    link: 'https://www.snapchat.com/add/spider9480?share_id=qfQTyyxuGEU&locale=en-US'
  },

  {
    name: 'Spotify',
    img: spotify,
    color: '#ffffff',
    link: 'https://open.spotify.com/playlist/1AMNYW1wrSLp5AeOH2W3Fb?si=0JICpd3XTaCh3wdGT716KQ&utm_source=copy-link'
  },
  {
    name: 'Telegram',
    img: telegram,
    color: '#ffffff',
    link: 'https://t.me/spider9480'
  },
  {
    name: 'Twitter',
    img: twitter,
    color: '#ffffff',
    link: 'https://twitter.com/oom_gawande'
  },
  {
    name: 'Whatsapp',
    img: whatsapp,
    color: '#ffffff',
    link: ''
  }
];
